/* Demo stub — brak połączenia z API */
import { createNamedStub, createServiceStub } from "../demo/stubHelpers";


export default createServiceStub();
